// H-015: «Tiene adendas» junto al documento original, con el detalle desplegable (motivo, texto, autor y fecha). Solo lectura.
import type { Provenance } from '@medplum/fhirtypes';
import type { JSX } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EXT_ADENDA_TEXTO } from '../lib/audit/bloqueo';

/**
 * Autor y fecha que puso el SERVIDOR (`meta.author`, `meta.lastUpdated`); el display y `recorded` los escribe el navegador, así que solo sirven de respaldo
 * y se rotulan como declarados por el cliente.
 */
export function autorYFecha(a: Provenance, rotuloCliente: string): string {
  const autorServidor = a.meta?.author?.display ?? a.meta?.author?.reference;
  const fechaServidor = a.meta?.lastUpdated;
  if (autorServidor && fechaServidor) return `${autorServidor} · ${new Date(fechaServidor).toLocaleString('es-EC')}`;
  const autor = autorServidor ?? a.agent?.[0]?.who?.display ?? a.agent?.[0]?.who?.reference ?? '—';
  const fecha = fechaServidor ?? a.recorded;
  return `${autor} · ${fecha ? new Date(fecha).toLocaleString('es-EC') : '—'} (${rotuloCliente})`;
}

export function AdendasDelDocumento({ adendas, idPanel }: { readonly adendas: readonly Provenance[]; readonly idPanel: string }): JSX.Element | null {
  const { t } = useTranslation();
  const [abierto, setAbierto] = useState(false);
  if (adendas.length === 0) return null;
  return (
    <div className="mt-1 text-sm">
      <button type="button" className="text-hce-pine underline-offset-2 hover:underline" aria-expanded={abierto} aria-controls={idPanel} onClick={() => setAbierto((v) => !v)}>
        {t('fichaPaciente.adenda.tieneAdendas', { count: adendas.length })}
      </button>
      {abierto && (
        <ul id={idPanel} className="mt-1 flex flex-col gap-2 border-l-2 border-border pl-3">
          {adendas.map((a, i) => (
            <li key={a.id ?? i}>
              <p className="text-xs text-muted-foreground">{autorYFecha(a, t('fichaPaciente.adenda.declaradoPorCliente'))}</p>
              <p>
                <span className="font-medium">{t('fichaPaciente.adenda.motivo')}: </span>
                {a.reason?.[0]?.text ?? '—'}
              </p>
              <p className="whitespace-pre-wrap">{a.extension?.find((e) => e.url === EXT_ADENDA_TEXTO)?.valueString ?? ''}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
